import { PaginationType } from 'common';
import { InspectionType } from 'state';
import { AppRootStateType } from 'state/reducers';

export const selectInspections = (state: AppRootStateType): InspectionType[] =>
  state.inspections.inspections;

export const selectInspectionsSearch = (state: AppRootStateType): string | undefined =>
  state.inspections.search;

export const selectInspectionsPagination = (state: AppRootStateType): PaginationType => ({
  page: state.inspections.page,
  count: state.inspections.count ?? 0,
});

export const selectCertainInspection = (state: AppRootStateType): InspectionType =>
  state.inspections.certainInspection;

export const selectInspectionsIsLoading = (state: AppRootStateType): boolean =>
  state.inspections.isLoading;
